import styled from 'styled-components';
import ModalComponent from 'react-bootstrap/Modal';

export const Container = styled.div`
  min-width: calc(100% - 88px);

  .btn-new {
    border-radius: 4px;
    background: #ff6900;
    border: none;
  }

  .iframe-container {
    height: calc(100vh - 105px);
    border-radius: 0 0 15px 15px;
    overflow: hidden;
  }

  h1 {
    font-size: 26px;
    font-weight: 500;
  }

  hr {
    background: #e1e1e1;
    opacity: 1;
  }

  a {
    :hover {
      color: unset;
    }
  }

  iframe {
    border-radius: 8px;
  }
`;

export const Modal = styled(ModalComponent)`
  .btn-filter {
    background: #002f6c;
    border: none;
    color: #fff;
  }
`;
